import TruncatedLabel from "./TruncatedLabel";

## Basic Usage

<div style={{ maxWidth: "200px" }}>
  <TruncatedLabel>
    This is a very long label that will be truncated when it exceeds the container width
  </TruncatedLabel>
</div>

---

## Truncation Comparison

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <div>
    <p style={{ marginBottom: "0.25rem", color: "#666", fontSize: "14px" }}>Container: 300px</p>
    <div style={{ maxWidth: "300px", border: "1px dashed #ccc", padding: "0.5rem" }}>
      <TruncatedLabel>Short text fits without truncation</TruncatedLabel>
    </div>
  </div>
  <div>
    <p style={{ marginBottom: "0.25rem", color: "#666", fontSize: "14px" }}>Container: 200px</p>
    <div style={{ maxWidth: "200px", border: "1px dashed #ccc", padding: "0.5rem" }}>
      <TruncatedLabel>This text is longer and will be truncated with an ellipsis</TruncatedLabel>
    </div>
  </div>
  <div>
    <p style={{ marginBottom: "0.25rem", color: "#666", fontSize: "14px" }}>Container: 150px</p>
    <div style={{ maxWidth: "150px", border: "1px dashed #ccc", padding: "0.5rem" }}>
      <TruncatedLabel>This text is longer and will be truncated with an ellipsis</TruncatedLabel>
    </div>
  </div>
</div>

Hover over truncated labels to see the full text in a tooltip.

---

## Custom Tooltip Delay

<div style={{ maxWidth: "200px" }}>
  <TruncatedLabel tooltipDelay={200}>
    Hover to see tooltip quickly (200ms delay) - this is a very long label text
  </TruncatedLabel>
</div>

---

## In a Table

<table style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead>
    <tr style={{ borderBottom: "1px solid #e5e5e5" }}>
      <th style={{ textAlign: "left", padding: "0.5rem", width: "150px" }}>Name</th>
      <th style={{ textAlign: "left", padding: "0.5rem", width: "200px" }}>Description</th>
      <th style={{ textAlign: "left", padding: "0.5rem" }}>Status</th>
    </tr>
  </thead>
  <tbody>
    <tr style={{ borderBottom: "1px solid #e5e5e5" }}>
      <td style={{ padding: "0.5rem" }}>
        <TruncatedLabel>Project Alpha</TruncatedLabel>
      </td>
      <td style={{ padding: "0.5rem" }}>
        <TruncatedLabel>A comprehensive project with many features and integrations</TruncatedLabel>
      </td>
      <td style={{ padding: "0.5rem" }}>Active</td>
    </tr>
    <tr style={{ borderBottom: "1px solid #e5e5e5" }}>
      <td style={{ padding: "0.5rem" }}>
        <TruncatedLabel>Marketing Campaign Q4</TruncatedLabel>
      </td>
      <td style={{ padding: "0.5rem" }}>
        <TruncatedLabel>End of year marketing initiative targeting new customers</TruncatedLabel>
      </td>
      <td style={{ padding: "0.5rem" }}>Pending</td>
    </tr>
    <tr>
      <td style={{ padding: "0.5rem" }}>
        <TruncatedLabel>Infrastructure Upgrade</TruncatedLabel>
      </td>
      <td style={{ padding: "0.5rem" }}>
        <TruncatedLabel>Server and database performance improvements</TruncatedLabel>
      </td>
      <td style={{ padding: "0.5rem" }}>Complete</td>
    </tr>
  </tbody>
</table>

---

## File List Example

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", overflow: "hidden" }}>
  <div style={{ display: "flex", alignItems: "center", padding: "0.5rem 0.75rem", borderBottom: "1px solid #e5e5e5" }}>
    <span style={{ marginRight: "0.5rem" }}>1</span>
    <div style={{ flex: 1, minWidth: 0 }}>
      <TruncatedLabel>very-long-filename-that-needs-to-be-truncated.tsx</TruncatedLabel>
    </div>
  </div>
  <div style={{ display: "flex", alignItems: "center", padding: "0.5rem 0.75rem", borderBottom: "1px solid #e5e5e5" }}>
    <span style={{ marginRight: "0.5rem" }}>2</span>
    <div style={{ flex: 1, minWidth: 0 }}>
      <TruncatedLabel>another-extremely-long-component-name-file.module.scss</TruncatedLabel>
    </div>
  </div>
  <div style={{ display: "flex", alignItems: "center", padding: "0.5rem 0.75rem" }}>
    <span style={{ marginRight: "0.5rem" }}>3</span>
    <div style={{ flex: 1, minWidth: 0 }}>
      <TruncatedLabel>short.ts</TruncatedLabel>
    </div>
  </div>
</div>

---

## With Custom Title

For non-string content, you can provide a custom `title` prop:

<div style={{ maxWidth: "150px" }}>
  <TruncatedLabel title="Custom tooltip text that's different from the content">
    <span>
      <strong>Bold</strong> and <em>italic</em> content
    </span>
  </TruncatedLabel>
</div>


